import ServicePage from './page';
import { corporateInsuranceData } from '@/mocks/servicePagesBatch2';

export default function CorporateInsurancePage() {
  return <ServicePage data={corporateInsuranceData} />;
}